import blocks from 'components/application/entryBlocks/blocks';

export default {
	...blocks,
};
